import { createStore } from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    user: null,
    accessToken: null,
    isAuthenticated: false,

    error: null,
    navScrollPosition: 0,

    userRole: {},
    roleLevel: null,
    userInfo: null,

    countryCodes: {},
    StudentCountry: {},
    StudentStates: {},
    StudentDistricts: {},
    StudentCities: {},
    nationality: {},

    leadCountry: {},
    leadState: {},
    leadCity: {},

    permissions: null,
    isPermissionsReady: false,
    currentPayment: null,
    actionPermissions: null,

    studentLeftNavCollapsed: false,
    tokenExp: null,

    notificationCount: null,
    customColumnData: [],
    applicationCustomColumnData: [],

    notificationData: [],
  },
  getters: {
    isStudentLeftNavCollapsed: (state) => state.studentLeftNavCollapsed,
    getCurrentPayment: (state) => state.currentPayment,
    isPermissionReady: (state) => state.isPermissionsReady,
    getRoleLevel: (state) => state.roleLevel,
    isAuthenticated: (state) => state.isAuthenticated,
    getAccessToken: (state) => state.accessToken,
    getError: (state) => state.error,

    getUser: (state) => state.user,
    getRole: (state) => state.userRole,
    getUserInfo: (state) => state.userInfo,

    getCountryCodes: (state) => state.countryCodes,
    getStudentCountry: (state) => state.StudentCountry,
    getStudentState: (state) => state.StudentStates,
    getStudentDistricts: (state) => state.StudentDistricts,
    getStudentCity: (state) => state.StudentCities,
    getNationality: (state) => state.nationality,

    getCountry: (state) => state.leadCountry,
    getState: (state) => state.leadState,
    getCity: (state) => state.leadCity,

    getPermissions: (state) => state.permissions,
    getActionPermissions: (state) => state.actionPermissions,
    getTokenExp: (state) => state.tokenExp,

    getNotificationCount: (state) => state.notificationCount,
    getColumnData: (state) => state.customColumnData,
    getApplicationCustomColumnData: (state) =>
      state.applicationCustomColumnData,
    getNotificationData: (state) => state.notificationData,
  },
  mutations: {
    setNotificationCount(state, count) {
      state.notificationCount = count;
    },
    setStudentLeftNavCollapsed(state, status) {
      state.studentLeftNavCollapsed = status;
    },
    setActionPermissions(state, permissions) {
      state.actionPermissions = permissions;
    },
    SET_CURRENT_PAYMENT(state, paymentList) {
      state.currentPayment = paymentList;
    },
    CLEAR_CURRENT_PAYMENT(state) {
      state.currentPayment = null;
    },
    setPermissionReadyStatus(state, status) {
      state.isPermissionsReady = status;
    },
    setRoleLevel(state, level) {
      state.roleLevel = level;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    setNavScrollPosition(state, position) {
      state.navScrollPosition = position;
    },
    setNationality(state, nationality) {
      state.nationality = nationality;
    },
    setUser(state, user) {
      state.user = user;
    },
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    setIsAuthenticated(state, status) {
      state.isAuthenticated = status;
    },
    setError(state, error) {
      state.error = error;
    },
    setUserRole(state, userRole) {
      state.userRole = userRole;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setCountryCodes(state, countryCode) {
      state.countryCodes = countryCode;
    },

    setStudentCountry(state, country) {
      state.StudentCountry = country;
    },
    setStudentState(state, states) {
      state.StudentStates = states;
    },
    setStudentCity(state, city) {
      state.StudentCities = city;
    },
    setStudentDistricts(state, district) {
      state.StudentDistricts = district;
    },

    setLeadCountry(state, country) {
      state.leadCountry = country;
    },
    setLeadState(state, states) {
      state.leadState = states;
    },
    setLeadCity(state, city) {
      state.leadCity = city;
    },
    setExpDate(state, date) {
      state.tokenExp = date;
    },
    setColumnFieldData(state, data) {
      state.customColumnData = data;
    },
    setApplicationColumnData(state, data) {
      state.applicationCustomColumnData = data;
    },
    setNotificationList(state, data) {
      state.notificationData = data;
    },
  },
  actions: {
    setCustomColumnData({ commit }, data) {
      commit("setColumnFieldData", data);
    },
    setApplicationColumn({ commit }, data) {
      commit("setApplicationColumnData", data);
    },
    addNotificationData({ commit }, data) {
      commit("setNotificationList", data);
    },
    async getNationality({ getters, commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/list-nationality/`,
          { headers: { Authorization: `Bearer ${getters.getAccessToken}` } },
        );
        commit(
          "setNationality",
          response.status === 200 ? response.data.data : {},
        );
      } catch (error) {
        console.error("Error fetching  nationalities:", error);
        commit("setNationality", {});
      }
    },
    async getCountryCodes({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/country-code/list/`,
        );
        commit("setCountryCodes", response.status === 200 ? response.data : {});
      } catch (error) {
        console.error("Error fetching Country codes:", error);
        commit("setCountryCodes", {});
      }
    },
    async getLeadCountry({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/leadapp/list-country/`,
        );
        commit("setLeadCountry", response ? response.data : {});
      } catch (error) {
        console.error("Error fetching Countries:", error);
        commit("setLeadCountry", {});
      }
    },
    async getLeadState({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/leadapp/list-state/`,
        );
        commit("setLeadState", response ? response : {});
      } catch (error) {
        console.error("Error fetching Countries:", error);
        commit("setLeadState", {});
      }
    },
    async getLeadCity({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/leadapp/list-city/`,
        );
        commit("setLeadCity", response ? response.data : {});
      } catch (error) {
        console.error("Error fetching Countries:", error);
        commit("setLeadCity", {});
      }
    },
    async getStudentCountry({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/list-country/`,
        );
        commit(
          "setStudentCountry",
          response.status === 200 ? response.data.data : {},
        );
      } catch (error) {
        console.error("Error fetching Countries:", error);
        commit("setStudentCountry", {});
      }
    },
    async getStudentState({ getters, commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/list-state/`,
          { headers: { Authorization: `Bearer ${getters.getAccessToken}` } },
        );
        commit(
          "setStudentState",
          response.status === 200 ? response.data.data : {},
        );
      } catch (error) {
        console.error("Error fetching States:", error);
        commit("setStudentState", {});
      }
    },
    async getStudentDistricts({ getters, commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/list-district/`,
          { headers: { Authorization: `Bearer ${getters.getAccessToken}` } },
        );
        commit(
          "setStudentDistricts",
          response.status === 200 ? response.data.data : {},
        );
      } catch (error) {
        console.error("Error fetching Districts:", error);
        commit("setStudentDistricts", {});
      }
    },
    async getStudentCity({ getters, commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/list-city/`,
          { headers: { Authorization: `Bearer ${getters.getAccessToken}` } },
        );
        commit(
          "setStudentCity",
          response.status === 200 ? response.data.data : {},
        );
      } catch (error) {
        console.error("Error fetching Cities:", error);
        commit("setStudentCity", {});
      }
    },
    async login({ commit }, { email, password, device_token }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/api/v1/accounts/login/`,
          { email, password, device_token },
        );
        if (response.data.status == 200) {
          const val =
            response?.data?.user_access.length > 0
              ? response?.data?.user_access.map(
                  (module) => module.permission.name,
                )
              : [];
          commit("setPermissions", val);
          if (val) {
            commit("setPermissionReadyStatus", true);
          }
          commit("setActionPermissions", response?.data?.user_access || null);
          commit(
            "setRoleLevel",
            response?.data?.user_profile?.role_level?.name,
          );

          commit("setIsAuthenticated", true);
          commit("setAccessToken", response.data.access_token);
          commit("setUser", response?.data?.user_id);
          commit("setUserRole", response?.data?.user_role);
          commit("setUserInfo", response?.data);
          commit("setNavScrollPosition", 0);
          commit("setError", null);
          this.dispatch("saveToken");
          this.dispatch("getCountryCodes");
          this.dispatch("getStudentCountry");
          this.dispatch("getStudentState");
          this.dispatch("getStudentDistricts");
          this.dispatch("getStudentCity");
          this.dispatch("getNationality");

          this.dispatch("getLeadCountry");
          this.dispatch("getLeadState");
          this.dispatch("getLeadCity");

          this.dispatch("getNotificationCount");
        } else {
          commit("setError", response.data.message);
          commit("setIsAuthenticated", false);
          setTimeout(() => {
            commit("setError", null);
          }, 5000);
        }
      } catch (error) {
        commit("setError", error.response?.data?.message) ||
          "An error occurred during login";
        commit("setIsAuthenticated", false);
        commit("setUser", null);
        commit("setAccessToken", null);
      }
    },
    logout({ commit }) {
      commit("setIsAuthenticated", false);
      commit("setNotificationList", []);
      commit("setColumnFieldData", []);
      setTimeout(() => {
        commit("setUser", null);
        commit("setUserInfo", null);
        commit("setUserRole", {});
        commit("setAccessToken", null);
        commit("setExpDate", null);
        commit("setNavScrollPosition", 0);
        commit("setPermissions", null);
        sessionStorage.clear();
        commit("setNationality", {});

        commit("setStudentCountry", {});
        commit("setStudentState", {});
        commit("setStudentCity", {});
        commit("setStudentDistricts", {});

        commit("setLeadCountry", {});
        commit("setLeadState", {});
        commit("setLeadCity", {});
        commit("setPermissionReadyStatus", false);
        commit("setNotificationCount", null);
        commit("setStudentLeftNavCollapsed", false);
      }, 300);
    },
    saveToken({ state, commit }) {
      const token = state.accessToken;
      if (!token) return;
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join(""),
        );
        const decoded = JSON.parse(jsonPayload);
        const expDate = new Date(decoded.exp * 1000);
        commit("setExpDate", expDate);
      } catch (err) {
        console.error("Failed to decode JWT:", err);
      }
    },
    async getNotificationCount({ getters, commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/api/v1/studentportal/push-notification-list/?user=${getters.getUser}&is_read=false`,
          { headers: { Authorization: `Bearer ${getters.getAccessToken}` } },
        );
        commit(
          "setNotificationCount",
          response.status === 200 ? response.data.count : null,
        );
      } catch (error) {
        console.error("Error fetching notification count:", error);
      }
    },
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => {
          try {
            const data = ls.get(key);
            return data ? JSON.parse(data) : null;
          } catch (e) {
            console.warn("Invalid JSON in storage, resetting:", e);
            ls.remove(key);
            return null;
          }
        },
        setItem: (key, value) => ls.set(key, JSON.stringify(value)),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
